export const verifyLogin = async (loginVm, emailVerify) => {
  if (emailVerify !== undefined && !emailVerify) {
    throw new Error('E-Mail adresse muss zuerst bestätigt werden.');
  }
};

const throwErrorIfNotDefined = (object, errorMessage) => {
  if (object === null || object === undefined || object === '') {
    throw new Error(errorMessage);
  }
};
const throwErrorIfRegexDidntMatch = (regex, string, errorMessage) => {
  const execRegex = regex.exec(string);
  if (throwErrorIfNotDefined(execRegex, errorMessage) || execRegex.length !== 1) {
    throw new Error(errorMessage);
  }
};

export const verifyRegister = async registerVm => {
  throwErrorIfNotDefined(registerVm, 'Bitte füllen Sie die Felder aus.');
  const {
    email, password, acceptAGBs
  } = registerVm;

  throwErrorIfNotDefined(email, 'E-Mail darf nicht leer sein.');
  throwErrorIfNotDefined(password, 'Das Passwort sollte nicht leer sein.');
  throwErrorIfRegexDidntMatch(/[^@]+@[^@]+\.[^@]+/, email, 'Ungültige E-Mail adresse.');
  if (!acceptAGBs) {
    throw new Error('Damit der Benutzer registriert werden kann, müssen die AGB`s akzeptiert werden.');
  }
  return registerVm;
};

export const verifyUsersettings = async usersettingsVm => {
  throwErrorIfNotDefined(usersettingsVm, 'Bitte füllen Sie die Felder aus.');
  const {
    place, displayName, birthday
  } = usersettingsVm;

  throwErrorIfNotDefined(place, 'Bitte füllen Sie Ihren Wohnort aus.');
  throwErrorIfNotDefined(displayName, 'Bitte geben Sie einen Anzeigename an.');

  if (birthday && (new Date(birthday) > new Date() || Number.isNaN(birthday))) {
    throw new Error('Das Geburtsjahr ist ungültig.');
  }

  return usersettingsVm;
};

export const verifyPet = async pet => {
  throwErrorIfNotDefined(pet, 'Bitte füllen Sie die Felder aus.');
  const {
    name, species
  } = pet;

  throwErrorIfNotDefined(name, 'Der Name darf nicht leer sein.');
  throwErrorIfNotDefined(species, 'Bitte geben Sie eine gültige Tierart an.');

  return pet;
};

export const verifyRequest = async request => {
  throwErrorIfNotDefined(request, 'Bitte füllen Sie die Felder aus.');
  const { pets2Pate, from, to } = request;

  throwErrorIfNotDefined(pets2Pate, 'Es muss mindestens ein Pet angewählt werden.');
  throwErrorIfNotDefined(from, 'Das von-Datum muss aufgefüllt werden.');
  throwErrorIfNotDefined(to, 'Das bis-Datum muss ausgefüllt werden.');

  if (pets2Pate.length === 0) {
    throw new Error('Es muss mindestens ein Pet angewählt werden.');
  }
  if (new Date(from) < new Date().setDate(new Date().getDate() - 1) || Number.isNaN(from)) {
    throw new Error('Das von-Datum ist ungültig oder liegt in der Vergangenheit.');
  }
  if (new Date(to) < new Date() || Number.isNaN(to)) {
    throw new Error('Das bis-Datum ist ungültig oder liegt in der Vergangenheit.');
  }
  if (to < from) {
    throw new Error('Das bis-Datum kann nicht kleiner als das von-Datum.');
  }

  return request;
};



// WEBPACK FOOTER //
// ./src/actions/validation.js